import { render, staticRenderFns } from "./GenericError.vue?vue&type=template&id=5ee73d0d&"
import script from "./GenericError.vue?vue&type=script&lang=ts&"
export * from "./GenericError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports